import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from "../../Icon";
import styles from "../styles.pcss";
var cx = classNames.bind(styles);
var isValueEmpty = function isValueEmpty(value) {
  return value === undefined || value === null;
};
export var DropdownCustom = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropdownCustom, _React$PureComponent);
  var _super = _createSuper(DropdownCustom);
  function DropdownCustom(props) {
    var _this;
    _classCallCheck(this, DropdownCustom);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getSelectedLabel", function () {
      return _this.props.options.reduce(function (acc, next) {
        return next.value === _this.props.value ? next.label : acc;
      }, _this.props.placeholder);
    });
    _defineProperty(_assertThisInitialized(_this), "getLongestLabel", function () {
      return _this.props.options.reduce(function (acc, next) {
        return acc.length >= next.label.length ? acc : next.label;
      }, '');
    });
    _defineProperty(_assertThisInitialized(_this), "addEventListeners", function () {
      document.addEventListener('click', _this.handleOutsideClick, false);
      document.addEventListener('touchstart', _this.handleOutsideClick, false);
    });
    _defineProperty(_assertThisInitialized(_this), "removeEventListeners", function () {
      document.removeEventListener('click', _this.handleOutsideClick, false);
      document.removeEventListener('touchstart', _this.handleOutsideClick, false);
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
      return _this.setState({
        opened: true
      }, _this.addEventListeners);
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      return _this.setState({
        opened: false
      }, _this.removeEventListeners);
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (value) {
      if (value !== _this.props.value) {
        _this.props.onChange(value);
      }
      _this.handleClose();
    });
    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (event) {
      if (!_this.node.contains(event.target)) {
        _this.handleClose();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      return !_this.state.opened && _this.handleOpen();
    });
    _defineProperty(_assertThisInitialized(_this), "renderOption", function (_ref) {
      var value = _ref.value,
        label = _ref.label;
      return /*#__PURE__*/React.createElement("div", {
        className: cx({
          selected: _this.props.value === value
        }, 'option'),
        key: "dropdown-option-".concat(label, "-").concat(value),
        onClick: function onClick() {
          return _this.handleSelect(value);
        },
        role: "button",
        tabIndex: 0
      }, label);
    });
    _defineProperty(_assertThisInitialized(_this), "renderList", function () {
      if (!_this.state.opened) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: cx('list')
      }, _this.props.options.map(_this.renderOption));
    });
    _this.state = {
      opened: _this.props.demoState === 'opened'
    };
    return _this;
  }
  _createClass(DropdownCustom, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return this.removeEventListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        disabled = _this$props.disabled,
        wide = _this$props.wide,
        value = _this$props.value,
        collapsed = _this$props.collapsed,
        status = _this$props.status;
      var opened = this.state.opened;
      var classes = cx({
        opened: opened,
        disabled: disabled,
        wide: wide,
        empty: isValueEmpty(value)
      }, this.props.className, 'dropdown', "".concat(this.props.size, "Size"), status);
      var scaleRatio = this.props.size === 'big' ? 1 : 0.75;
      var handleClick = opened ? this.handleClose : this.handleOpen;
      return /*#__PURE__*/React.createElement("div", {
        className: cx({
          wide: wide,
          collapsed: collapsed
        }, 'wrapper'),
        ref: function ref(node) {
          _this2.node = node;
        }
      }, /*#__PURE__*/React.createElement("input", {
        disabled: disabled,
        name: this.props.name,
        type: "hidden",
        value: value || ''
      }), /*#__PURE__*/React.createElement("div", {
        className: classes,
        onClick: disabled ? null : handleClick
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('value')
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('valueStretcher')
      }, this.getLongestLabel()), /*#__PURE__*/React.createElement("div", {
        className: cx('valueText')
      }, this.getSelectedLabel())), this.renderList(), /*#__PURE__*/React.createElement(Icon, {
        className: cx('arrow'),
        name: "dropdownArrow",
        scale: scaleRatio
      })));
    }
  }]);
  return DropdownCustom;
}(React.PureComponent);
_defineProperty(DropdownCustom, "defaultProps", {
  placeholder: 'Выберите значение',
  size: 'default',
  name: null,
  wide: false,
  collapsed: false,
  className: null,
  demoState: null
});
DropdownCustom.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    label: PropTypes.string
  })).isRequired,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  wide: PropTypes.bool,
  collapsed: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big']),
  demoState: PropTypes.oneOf(['opened']),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
} : {};